import { PLATFORM_IOS, PLATFORM_ANDROID, PLATFORM_H5 } from '@/utils/constant.js'

const getPlatform = () => {
  let v
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    v = PLATFORM_IOS
  } else if (/(Android)/i.test(navigator.userAgent)) {
    v = PLATFORM_ANDROID
  } else {
    v = PLATFORM_H5
  }
  return v
}

export default getPlatform

